import "./pointsOutcomeView.scss";

const METRIC_LABEL_MAP = {
  SPEND: "Spend",
};

const RecalculateTierView = ({ data, definition }) => {
  const metric = data?.metric;
  const metricLabel = METRIC_LABEL_MAP[metric] || metric || "—";

  return (
    <div className="points-outcome-view" data-testid="recalculate-tier-view">
      <h5>{definition?.outcomeDefinition?.name}</h5>
      <ul className="outcome-summary-list">
        <li>Member tier is evaluated when the activity is performed.</li>
        <li>
          Qualification Metric: <strong>{metricLabel}</strong>
        </li>
      </ul>
    </div>
  );
};

export default RecalculateTierView;
